import api from "../api";
import {createError, logError, logSuccess} from "./message";
import types from "./types";

function requestProgramBlocks() {
  return {
    type: types.GET_ALL_BLOCK_PROGRAM_REQUEST,
    fetchingAllProgramBlock: true
  };
}

function requestProgramBlocksCompleted(allProgramBlock) {
  return {
    type: types.GET_ALL_BLOCK_PROGRAM_COMPLETED,
    fetchingAllProgramBlock: false,
    allProgramBlock
  };
}

function requestProgramBlocksError(fetchingAllProgramBlockError) {
  return {
    type: types.GET_ALL_BLOCK_PROGRAM_ERROR,
    fetchingAllProgramBlock: false,
    fetchingAllProgramBlockError
  };
}

export function getProgramBlocks(id) {
  return dispatch => {
    dispatch(requestProgramBlocks());
    return api.getBlocks(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestProgramBlocksCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }

          logError(message);
          dispatch(requestProgramBlocksError(message));
        } else {
          logError(err);
          dispatch(requestProgramBlocksError(createError("Не удалось загрузить блоки программы")));
        }
      });
  };
}

function requestProgramModules() {
  return {
    type: types.GET_ALL_MODULE_PROGRAM_REQUEST,
    fetchingAllProgramModule: true
  };
}

function requestProgramModulesCompleted(allProgramModule) {
  return {
    type: types.GET_ALL_MODULE_PROGRAM_COMPLETED,
    fetchingAllProgramModule: false,
    allProgramModule
  };
}

function requestProgramModulesError(fetchingAllProgramModuleError) {
  return {
    type: types.GET_ALL_MODULE_PROGRAM_ERROR,
    fetchingAllProgramModule: false,
    fetchingAllProgramModuleError
  };
}

export function getAllProgramModules(id) {
  return dispatch => {
    dispatch(requestProgramModules());
    return api.getModules(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestProgramModulesCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }

          logError(message);
          dispatch(requestProgramModulesError(message));
        } else {
          logError(err);
          dispatch(requestProgramModulesError(createError("Не удалось загрузить модули программы")));
        }
      });
  };
}

export function getBlockModules(id) {
  return dispatch => {
    dispatch(requestProgramModules());
    return api.getModulesByBlock(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestProgramModulesCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }

          logError(message);
          dispatch(requestProgramModulesError(message));
        } else {
          logError(err);
          dispatch(requestProgramModulesError(createError("Не удалось загрузить модули программы")));
        }
      });
  };
}

function requestProgramAuthors() {
  return {
    type: types.GET_PROGRAM_AUTHORS_REQUEST,
    fetchingProgramAuthors: true
  };
}

function requestProgramAuthorsCompleted(authors) {
  return {
    type: types.GET_PROGRAM_AUTHORS_COMPLETED,
    fetchingProgramAuthors: false,
    authors
  };
}

function requestProgramAuthorsError(authorsError) {
  return {
    type: types.GET_PROGRAM_AUTHORS_ERROR,
    fetchingProgramAuthors: false,
    authorsError
  };
}

export function getProgramAuthors(id) {
  return dispatch => {
    dispatch(requestProgramAuthors());
    return api.getProgramAuthors(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestProgramAuthorsCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }

          logError(message);
          dispatch(requestProgramAuthorsError(message));
        } else {
          logError(err);
          dispatch(requestProgramAuthorsError(createError("Не удалось загрузить составителей программы")));
        }
      });
  };
}

export default {
  getProgramBlocks,
  getAllProgramModules,
  getBlockModules,
  getProgramAuthors
}
